import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from './models/ui-state.models';

/**
 * UI Selectors
 * 
 * Memoized selectors for accessing UI state
 */

/**
 * Feature selector for UI state
 */
export const selectUiState = createFeatureSelector<UiState>('ui');

/**
 * Sidenav Selectors
 */
export const selectSidenavOpen = createSelector(
  selectUiState,
  (state) => state.sidenav.isOpen
);

export const selectGlobalLoading = createSelector(
  selectUiState,
  (state) => state.globalLoading
);
